<dx-validation-group #validatorResendEmail>
  <dx-responsive-box>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-col></dxi-col>
    <dxi-col></dxi-col>

    <dxi-item>
      <dxi-location [row]="0" [col]="0" [colspan]="2"></dxi-location>
      <div
        *dxTemplate
        class="resend-email-form-label-wrapper"
        [ngClass]="{ 'resend-email-form-label-wrapper-small': isSmallScreen }"
      >
        <label>Resend Validation Email</label>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="1" [col]="0" [colspan]="2"></dxi-location>
      <div *dxTemplate class="container-row">
        <dx-text-box
          class="cc-text-required"
          placeholder="Please enter your valid Email address"
          [(value)]="email"
          (onEnterKey)="resendValidationEmail(null)"
        >
          <dx-validator>
            <dxi-validation-rule
              type="required"
              message="Email is required"
            ></dxi-validation-rule>
            <dxi-validation-rule
              type="email"
              message="Email is invalid"
            ></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="2" [col]="0" [colspan]="2"></dxi-location>
      <div *dxTemplate class="container-row align-items-center">
        <re-captcha
          #reCaptcha
          [siteKey]="recaptchaSiteKey"
          errorMode="handled"
          (resolved)="onRecaptchaResolved($event)"
          (errored)="onRecaptchaErrored()"
        ></re-captcha>
        <p *ngIf="recaptchaErrorMessage" class="recaptcha-error-message">
          {{ recaptchaErrorMessage }}
        </p>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="3" [col]="0"></dxi-location>
      <div *dxTemplate class="container-row-button resend-email-button-wrapper">
        <div class="resend-email-button-content">
          <dx-button
            [icon]="resetIcon"
            text="Resend Email"
            type="default"
            class="button-content"
            [width]="isSmallScreen ? 110 : 130"
            [height]="30"
            (onClick)="resendValidationEmail($event)"
          ></dx-button>
        </div>
      </div>
    </dxi-item>
    <dxi-item>
      <dxi-location [row]="3" [col]="1"></dxi-location>
      <div *dxTemplate class="container-row-button align-items-start">
        <dx-button
          #btnLogin
          [icon]="backToLoginIcon"
          text="Back To Login"
          type="default"
          class="button-content"
          [width]="isSmallScreen ? 120 : 130"
          [height]="30"
          (onClick)="backToLogin($event)"
        ></dx-button>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="4" [col]="0" [colspan]="2"></dxi-location>
      <div *dxTemplate class="container-row">
        <p class="center-content">
          <a [routerLink]="['/user/signup']">Create an Account</a>
        </p>
      </div>
    </dxi-item>
  </dx-responsive-box>
</dx-validation-group>

<dx-load-panel
  #loadPanelLogin
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#loginContainer' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
